<div class="row g-0 d-flex justify-content-center">

  <div class=" col-md-11" id="myTabContent0" [ngClass]="loading ? 'blur-background' : ''">

    <div class="" id="" role="tabpanel" aria-labelledby="key-container">
      <div class=" mt-4 mb-5">
        <div class=" content-card " id="col-id" #inst>
          <form class="  general-container" [formGroup]="instForm" novalidate>
            <div>
              <label for="publicKey" class="form-label mb-2"
                     style="font-size: large; font-weight: bold">General
                Details</label>
              <hr>
            </div>

            <div class="row mt-2">
              <div class="row">
                <div class="col-md-6 text-start">
                  <label for="institutionCode" class="form-label">Institution Code</label>
                  <input type="text" class="form-control" formControlName="institutionCode"
                         [readonly]="true">


                </div>
                <div class="col-md-6 text-start">
                  <label for="institutionName" class="form-label">Institution Name</label>
                  <input type="text" class="form-control" [readonly]="true"
                         formControlName="institutionName">

                </div>
                <div class="col-md-6 text-start">
                  <label for="institutionAddress" class="form-label">Address</label>
                  <input type="text" class="form-control" [readonly]="true"
                         formControlName="institutionAddress">

                </div>
                <div class="col-md-6 text-start">
                  <label for="institutionContactNo" class="form-label">Telephone Number</label>
                  <div class=" row d-flex">
                    <div class="col-md-3"><ngx-intl-tel-input style="width: 2vw" type="text"
                                                              id="contactNo" formControlName="institutionContactNo"
                                                              [enablePlaceholder]="true" [searchCountryFlag]="true"
                                                              [selectFirstCountry]="true" [separateDialCode]="true" [maxLength]="0"
                                                              [outerText]="" [phoneValidation]="false"
                                                              [enableAutoCountrySelect]="true" [readonly]="true"></ngx-intl-tel-input></div>
                    <div class=" col-md-9 sl-flex-row" id="contactNum">

                      <input class="form-control" formControlName="contactNo" [readonly]="true" />
                      <!-- <div class="invalid-feedback" *ngIf="formInstControl['contactNo'].errors['required']">
                    <div>&nbsp;&nbsp;Contact Number is required</div>
                  </div> -->
                    </div>
                  </div>


                </div>
                <!-- <div class="col-md-6 text-start">
                    <label for="institutionFaxNo" class="form-label">Fax Number</label>
                    <input type="text" class="form-control" [readonly]="true"
                        formControlName="institutionFaxNo">

                </div> -->
                <div class="col-md-6 text-start">
                  <label for="institutionEmail" class="form-label">Email address</label>
                  <input type="text" class="form-control" formControlName="institutionEmail"
                         [readonly]="true">

                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mt-3 ">
                  <div class="general-checkBox">
                    <input mdbchechbox onclick="return false;" type="checkbox" ng-model="check"
                           [checked]="true" />
                    GTN API Enabled
                  </div>
                  <div class="general-checkBox">
                    <input onclick="return false;" type="checkbox" ng-model="check"
                           formControlName="FixApiEnableCheck" />
                    FIX API Enabled
                  </div>
                  <div class="general-checkBox">
                    <input onclick="return false;" type="checkbox" ng-model="check"
                           formControlName="AccountApiEnableCheck" />
                    Backoffice API Enabled
                  </div>
                  <div  class="general-checkBox">
                    <input onclick="return false;" type="checkbox" ng-model="check" formControlName="DwmEnableCheck"/>
                    DWM enable
                  </div>
                </div>
                <div class="col-md-6 mt-3">
                  <div class="general-checkBox">
                    <input onclick="return false;" type="checkbox" ng-model="check"
                           formControlName="WithdrawAutoEnableCheck" />
                    Auto Withdraw Enabled
                  </div>
                  <div class="general-checkBox">
                    <input onclick="return false;" type="checkbox" ng-model="check"
                           formControlName="DepositAutoEnableCheck" />
                    Auto Deposit Enabled
                  </div>
                  <div class="general-checkBox">
                    <input onclick="return false;" type="checkbox" ng-model="check"
                           formControlName="bypassBuyingPower" />
                    Bypass Buying Power Enabled
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12 text-start">
                <label for="publicKey" class="form-label mb-2">Public
                  Key</label>
                <textarea [readonly]="true" type="text" class="form-control"
                          formControlName="publicKey"></textarea>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-6 text-start">
                <label for="appKey" class="form-label mb-2">App Key</label>
                <input [readonly]="true" type="text" class="form-control" formControlName="appKey" />

              </div>

              <div class="col-md-6 text-start">
                <label for="appSecret" class="form-label mb-2">App
                  Secret</label>
                <input [readonly]="true" type="text" class="form-control" formControlName="appSecret" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="" id="exchange" role="tabpanel">
      <div class="d-flex justify-content-center mb-4" style="padding-bottom: 0px; margin-top: 30px">
        <div class="" #inst>
          <div>
            <label for="publicKey" class="form-label mb-2"
                   style="font-size: large; font-weight: bold">Assigned Exchanges</label>
            <hr>
          </div>
          <form class="mt-3 " [ngClass]="loadingExchanges ? 'blur-background' : ''" [formGroup]="form"
                novalidate>
            <div *ngIf="loadingExchanges " class="position-absolute top-50 start-50 translate-middle vstack"
                 style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div class="row">
              <div class="col-md-12 text-start">
                <div>
                  <div class=" position-relative ">
                    <div class="table-container">
                      <table class="table table-sm summary-table">
                        <thead>
                        <tr>
                          <th scope="col">Exchange Code</th>
                          <th scope="col">Description</th>
                          <th scope="col">Pre Open</th>
                          <th scope="col">Open</th>
                          <th scope="col">Pre Close</th>
                          <th scope="col">Close</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr *ngFor="let exchange of Exchanges?.['list']">
                          <td *ngIf="exchange.exchangeCode">{{exchange.exchangeCode}}</td>
                          <td *ngIf="!exchange.exchangeCode">-</td>
                          <td *ngIf="exchange.description">{{exchange.description}}</td>
                          <td *ngIf="!exchange.description">-</td>
                          <td *ngIf="exchange.preOpen">{{exchange.preOpen}}</td>
                          <td *ngIf="!exchange.preOpen">-</td>
                          <td *ngIf="exchange.open">{{exchange.open}}</td>
                          <td *ngIf="!exchange.open">-</td>
                          <td *ngIf="exchange.preClose">{{exchange.preClose}}</td>
                          <td *ngIf="!exchange.preClose">-</td>
                          <td *ngIf="exchange.close">{{exchange.close}}</td>
                          <td *ngIf="!exchange.close">-</td>


                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="" id="bank" role="tabpanel">
      <div class="d-flex justify-content-center mb-5" style="padding-bottom: 0px;">
        <div class="" #inst>
          <div>
            <label for="publicKey" class="form-label mb-2"
                   style="font-size: large; font-weight: bold">Assigned Banks</label>
            <hr>
          </div>
          <form class="mt-3 " [ngClass]="loadingBank ? 'blur-background' : ''" [formGroup]="form" novalidate>
            <div *ngIf="loadingBank " class="position-absolute top-50 start-50 translate-middle vstack"
                 style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div class="row">
              <div class="col-md-12 text-start">
                <div>
                  <div class=" position-relative ">
                    <div class="table-container">
                      <table class="table table-sm summary-table">
                        <thead>
                        <tr>
                          <th scope="col">Bank Name</th>
                          <th scope="col">Swift Code</th>
                          <th scope="col">Tel</th>
                          <th scope="col">Status</th>
                          <th scope="col">Online Trading</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr *ngFor="let bank of instBankList?.['bankList']">
                          <td *ngIf="bank.bankName">{{bank.bankName}}</td>
                          <td *ngIf="!bank.bankName">-</td>
                          <td *ngIf="bank.swiftCode">{{bank.swiftCode}}</td>
                          <td *ngIf="!bank.swiftCode">-</td>
                          <td *ngIf="bank.telephoneNo">{{bank.telephoneNo}}</td>
                          <td *ngIf="!bank.telephoneNo">-</td>

                          <td *ngIf="bank.bankStatus">{{bank.bankStatus}}</td>
                          <td *ngIf="!bank.bankStatus">-</td>

                          <td *ngIf="bank.onlineTrading">{{bank.onlineTrading}}</td>
                          <td *ngIf="!bank.onlineTrading">-</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="" id="" role="tabpanel" aria-labelledby="bankAcc">
      <div class="d-flex justify-content-center mb-5" style="padding-bottom: 0px; margin-top: 30px">
        <div #inst>
          <div>
            <label for="publicKey" class="form-label mb-2" style="font-size: large; font-weight: bold">Bank
              Accounts</label>
            <hr>
          </div>
          <form class="mt-3 " [ngClass]="loadingBankAcc ? 'blur-background' : ''" [formGroup]="form"
                novalidate>
            <div *ngIf="loadingBankAcc " class="position-absolute top-50 start-50 translate-middle vstack"
                 style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div class="row">
              <div class="col-md-12 text-start">
                <div>
                  <div class=" position-relative mt-3">
                    <div class="table-container">
                      <table class="table table-sm summary-table">
                        <thead>
                        <tr>
                          <th scope="col">Account Number</th>
                          <th scope="col">Bank Name</th>
                          <th scope="col">Currency</th>
                          <th scope="col">Balance in Bank</th>
                          <th scope="col">Is Default</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr *ngFor="let bankAcc of bankDetails?.['bankAccountList']">
                          <td *ngIf="bankAcc.bankAccountNumber">
                            {{bankAcc.bankAccountNumber}}</td>
                          <td *ngIf="!bankAcc.bankAccountNumber">-</td>
                          <td *ngIf="bankAcc.bankName">{{bankAcc.bankName}}</td>
                          <td *ngIf="!bankAcc.bankName">-</td>
                          <td *ngIf="bankAcc.currency">{{bankAcc.currency}}</td>
                          <td *ngIf="!bankAcc.currency">-</td>
                          <td *ngIf="bankAcc.balance">{{bankAcc.balance}}</td>
                          <td *ngIf="!bankAcc.balance">0</td>
                          <td *ngIf="bankAcc.isDefault">{{bankAcc.isDefault}}</td>
                          <td *ngIf="!bankAcc.isDefault">-</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="" id="customer" role="tabpanel" *ngIf="!isTableEmptyProfile">
      <div>
        <label for="publicKey" class="form-label mb-2" style="font-size: large; font-weight: bold">Customer
          Profiles</label>
        <hr>
      </div>
      <div class="form mt-2">
        <div class="d-flex justify-content-center " style="padding: 10px 0px; ">
          <div class="" #inst>
            <form class="content-card position-relative content-card-devide"
                  [ngClass]="loadingCustomerProfile ? 'blur-background' : ''" [formGroup]="form" novalidate>
              <div *ngIf="loadingCustomerProfile "
                   class="position-absolute top-50 start-50 translate-middle vstack" style="z-index: 1000">
                <div class="spinner-border text-primary" style="width: 3rem; height: 3rem"
                     role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div class="loading-text">Loading...</div>
              </div>
              <div class="row">
                <div class="col-md-12 text-start">
                  <div>
                    <div class=" position-relative ">
                      <div class="table-container">
                        <table class="table table-hover table-cp">
                          <thead>
                          <tr>
                            <th scope="col">Profile Number</th>
                            <th scope="col">Profile Name</th>
                            <th scope="col">Profile Description</th>
                            <th scope="col">Status</th>
                            <th scope="col">Is Default</th>
                          </tr>
                          </thead>

                          <tbody>
                          <tr (click)="selectedRowCP($event,cusProfile.profileNumber,userInded,cusProfile.profileName)"
                              *ngFor="let cusProfile of instCustomerProfile?.['profileList']; let userInded = index"
                              [ngClass]="userInded ==  selectedUserIndex ? 'selRow' : ''">
                            <td *ngIf="cusProfile.profileNumber">
                              {{cusProfile.profileNumber}}</td>
                            <td *ngIf="!cusProfile.profileNumber">-</td>
                            <td *ngIf="cusProfile.profileName">
                              {{cusProfile.profileName}}
                            </td>
                            <td *ngIf="!cusProfile.profileName">-</td>
                            <td *ngIf="cusProfile.description">
                              {{cusProfile.description}}
                            </td>
                            <td *ngIf="!cusProfile.description">-</td>

                            <td *ngIf="cusProfile.status">{{cusProfile.status}}</td>
                            <td *ngIf="!cusProfile.status">-</td>

                            <td *ngIf="cusProfile.isDefault">{{cusProfile.isDefault}}
                            </td>
                            <td *ngIf="!cusProfile.isDefault">-</td>


                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <hr>
        <div class="table-content-down mt-3">
          <div role="tabpanel" style="border: 1px rgba(0, 0, 0, 0.267) solid; padding: 0px;">
            <div class="d-flex justify-content-center mt-1 ">
              <div #inst>
                <form class="content-card position-relative  content-card-devide-down"
                      [formGroup]="form" novalidate [ngClass]="loadingCP ? 'blur-background' : ''">
                  <div *ngIf="loadingCP "
                       class="position-absolute top-50 start-50 translate-middle vstack"
                       style="z-index: 1000">
                    <div class="spinner-border text-primary" style="width: 3rem; height: 3rem"
                         role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <div class="loading-text">Loading...</div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-start">
                      <div *ngIf="isSelectRowCP; else selectRow">
                        <label class="form-label" style="font-weight: bold">Profile Name :
                          {{customerName}}</label>
                        <div style="font-size: small;">
                          <div class=" position-relative mt-2">
                            <li>
                              <label class="form-label" style="font-weight: bold">Cash
                                Accounts</label>
                            </li>
                            <div class="table-container mt-1">
                              <table class="table table-sm"
                                     *ngFor="let cash of customerDetailsCP?.['cashAccounts']">
                                <thead>
                                <tr>
                                  <th scope="col">Cash A/C type</th>
                                  <th scope="col">Cash A/C No</th>
                                  <th scope="col">Currency</th>
                                  <th scope="col">Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                  <td *ngIf="cash.accountType == 0">Current</td>
                                  <td *ngIf="cash.accountType == 1">Savings</td>
                                  <td *ngIf="cash.accountType == 2">Investment
                                  </td>
                                  <td>{{cash.cashAccountNumber}}</td>
                                  <td>{{cash.currency}}</td>
                                  <td *ngIf="cash.status == 2">APPROVED</td>
                                  <td *ngIf="cash.status == 5">DELETE</td>
                                  <td
                                    *ngIf="cash.status != 2 && cash.status != 5">
                                    UNKNOWN
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class=" position-relative mt-1">
                            <li>
                              <label for="publicKey" class="form-label"
                                     style="font-weight: bold">Security
                                Accounts</label>
                            </li>
                            <div class="table-container mt-1"
                                 *ngFor="let cash of customerDetailsCP?.['cashAccounts']">
                              <table class="table table-sm"
                                     *ngFor="let security of cash?.['securityAccounts']">
                                <thead>
                                <tr>
                                  <th scope="col">Security A/C No</th>
                                  <th scope="col">Account Type</th>
                                  <th scope="col">Cash A/C No</th>
                                  <th scope="col">Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                  <td>{{security.accountNumber}}</td>
                                  <td *ngIf="security.accountType == 1">Equity
                                  </td>
                                  <td *ngIf="security.accountType == 2">Options
                                  </td>
                                  <td *ngIf="security.accountType == 3">Futures
                                  </td>
                                  <td *ngIf="security.accountType == 4">Forex</td>
                                  <td *ngIf="security.accountType == 5">CFD</td>
                                  <td *ngIf="security.accountType == 6">Spot</td>
                                  <td *ngIf="security.accountType == 7">Auto Trade
                                  </td>
                                  <td *ngIf="security.accountType == 8">Investment
                                  </td>
                                  <td *ngIf="security.accountType == 10">crypto
                                  </td>
                                  <td *ngIf="security.accountType == 11 ">
                                    Investor Portfolio
                                  </td>

                                  <td>{{security.cashAccountNumber}}</td>

                                  <td *ngIf="security.statusId == 2">APPROVED</td>
                                  <td *ngIf="security.statusId == 5">DELETE</td>
                                  <td
                                    *ngIf="security.statusId != 2 && security.statusId != 5">
                                    UNKNOWN
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class=" position-relative mt-1">
                            <li>
                              <label for="publicKey" class="form-label"
                                     style="font-weight: bold">Trading
                                Accounts</label>
                            </li>
                            <div class="table-container mt-1"
                                 *ngFor="let cash of customerDetailsCP?.['cashAccounts']">
                              <table class="table table-sm"
                                     *ngFor="let security of cash?.['securityAccounts']">
                                <ng-container
                                  *ngFor="let exchange of security?.['exchangeAccounts']">
                                  <thead>
                                  <tr>
                                    <th scope="col">Exchange A/C Id</th>
                                    <th scope="col">Security A/C No</th>
                                    <th scope="col">Exchange</th>
                                    <th scope="col">Trading Enable</th>
                                    <th scope="col">Executing Broker</th>
                                    <th scope="col">Status</th>
                                  </tr>
                                  </thead>

                                  <tbody>
                                  <tr>
                                    <td>{{exchange.exchangeAccountId}}</td>
                                    <td>
                                      {{security.accountNumber}}
                                    </td>
                                    <td>{{exchange.exchange}}</td>

                                    <td *ngIf="exchange.tradingEnabled == 1">Yes
                                    </td>
                                    <td *ngIf="exchange.tradingEnabled == 0">No
                                    </td>
                                    <td
                                      *ngIf="exchange.tradingEnabled != 0 && exchange.tradingEnabled != 1 ">
                                      nullddd
                                    </td>

                                    <td *ngIf="exchange.executingBrokerId">
                                      {{exchange.executingBrokerId}}
                                    </td>
                                    <td *ngIf="!exchange.executingBrokerId">null
                                    </td>

                                    <td *ngIf="exchange.status == 3">APPROVED
                                    </td>
                                    <td *ngIf="exchange.status == 6">DELETE</td>
                                    <td
                                      *ngIf="exchange.status != 3 && exchange.status != 6">
                                      UNKNOWN
                                    </td>
                                  </tr>
                                  </tbody>
                                </ng-container>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5" id="subscription" role="tabpanel" *ngIf="!isTableEmptyPackage">
      <div>
        <label for="publicKey" class="form-label mb-2" style="font-size: large; font-weight: bold">Subscription
          Packages</label>
        <hr>
      </div>
      <div class="form mt-2">
        <div class="d-flex justify-content-center " style="padding: 10px 0px; ">
          <div class="" #inst>
            <form class="content-card  position-relative content-card-devide"
                  [ngClass]="loadingSubscriptionPackage ? 'blur-background' : ''" [formGroup]="form"
                  novalidate>
              <div *ngIf="loadingSubscriptionPackage "
                   class="position-absolute top-50 start-50 translate-middle vstack" style="z-index: 1000">
                <div class="spinner-border text-primary" style="width: 3rem; height: 3rem"
                     role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div class="loading-text">Loading...</div>
              </div>
              <div class="row">
                <div class="col-md-12 text-start">
                  <div>
                    <div class=" position-relative mt-2">
                      <div class="table-container">
                        <table class="table table-hover table-cp">
                          <thead>
                          <tr style="background-color: rgba(0, 0, 0, 0.082);">
                            <th scope="col">Package ID</th>
                            <th scope="col">Package Name</th>
                            <th scope="col">Package Description</th>
                            <th scope="col">Status</th>
                            <th scope="col">IS Default</th>
                          </tr>
                          </thead>

                          <tbody>
                          <tr (click)="selectedRowSP($event,subsPackage,userIndedSP)"
                              *ngFor="let subsPackage of instSubscriptionPackages?.['packageList']; let userIndedSP = index"
                              [ngClass]="userIndedSP ==  selectedUserIndexSP ? 'selRow' : ''">
                            <td *ngIf="subsPackage.packageId">{{subsPackage.packageId}}
                            </td>
                            <td *ngIf="!subsPackage.packageId">-</td>
                            <td *ngIf="subsPackage.packageName">
                              {{subsPackage.packageName}}
                            </td>
                            <td *ngIf="!subsPackage.packageName">-</td>
                            <td *ngIf="subsPackage.packageDescription">
                              {{subsPackage.packageDescription}}
                            </td>
                            <td *ngIf="!subsPackage.packageDescription">-</td>
                            <td>0</td>
                            <td>0</td>

                          </tr>
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <hr>
        <div class="table-content-down mt-3">
          <div class="" id="" role="tabpanel" style="border: 1px rgba(0, 0, 0, 0.267) solid; padding: 0px;">
            <div class="d-flex justify-content-center mt-2 ">
              <div #inst>
                <form class="content-card position-relative content-card-devide-down" [formGroup]="form"
                      novalidate>
                  <div *ngIf="loadingBank "
                       class="position-absolute top-50 start-50 translate-middle vstack"
                       style="z-index: 1000">
                    <div class="spinner-border text-primary" style="width: 3rem; height: 3rem"
                         role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <div class="loading-text">Loading...</div>
                  </div>
                  <div class="row">
                    <div *ngIf="isSelectRowSP; else selectRowSP" class="col-md-12 text-start">
                      <label for="publicKey" class="form-label"
                             style="font-weight: bold; margin-top: 5px;">Assigned Exchanges relavant
                        to
                        {{packageName}}</label>
                      <div>
                        <div class=" position-relative mt-3">
                          <div class="table-container">
                            <table class="table table-sm" style="font-size: small;">
                              <thead>
                              <tr>
                                <th scope="col">Exchange</th>
                                <th scope="col">Feed Level</th>
                                <th scope="col">Currency</th>
                              </tr>
                              </thead>

                              <tbody>
                              <tr
                                *ngFor="let subExchange of subsPackages?.['exchangeList']">
                                <td *ngIf="subExchange.exchange">
                                  {{subExchange.exchange}}</td>
                                <td *ngIf="!subExchange.exchange">-</td>
                                <td *ngIf="subExchange.feedLevel">
                                  {{subExchange.feedLevel}}</td>
                                <td
                                  *ngIf="subExchange.feedLevel == '' || subExchange.feedLevel == null ">
                                  -</td>
                                <td *ngIf="subExchange.currency">
                                  {{subExchange.currency}}</td>
                                <td *ngIf="!subExchange.currency">-</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5" id="" role="tabpanel" aria-labelledby="masterAcc">
      <div class="d-flex justify-content-center mt-4 mb-5">
        <div #inst>
          <div>
            <label for="publicKey" class="form-label mb-2"
                   style="font-size: large; font-weight: bold">Master Accounts</label>
            <hr>
          </div>
          <form class="form mt-3 content-card" [ngClass]="loading ? 'blur-background' : ''"
                [formGroup]="instForm" novalidate id="collapse1">
            <div *ngIf="loading " class=" top-50 start-50 translate-middle vstack" style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div class="row ">
              <div class="mt-2 col-md-6 text-start">
                <label for="masterAccLastName" class="form-label">Name</label>
                <input type="text" class="form-control" ng-required="expression"
                       formControlName="masterAccLastName" [readonly]="true">
              </div>
              <div class="mt-2 col-md-6 text-start">
                <label for="masterAccContactNoMobile" class="form-label">Contact Number (Mobile)</label>
                <div class=" row d-flex">
                  <div class="col-md-3"><ngx-intl-tel-input style="width: 2vw" type="text"
                                                            id="contactNo" formControlName="institutionContactNo"
                                                            [enablePlaceholder]="true" [searchCountryFlag]="true"
                                                            [selectFirstCountry]="true" [separateDialCode]="true" [maxLength]="0"
                                                            [outerText]="" [phoneValidation]="false"
                                                            [enableAutoCountrySelect]="true" [readonly]="true"></ngx-intl-tel-input></div>
                  <div class=" col-md-9 sl-flex-row" id="contactNum">

                    <input class="form-control"
                           formControlName="masterAccContactNoMobile" [readonly]="true" />
                    <!-- <div class="invalid-feedback" *ngIf="formInstControl['contactNo'].errors['required']">
                  <div>&nbsp;&nbsp;Contact Number is required</div>
                </div> -->
                  </div>
                </div>
              </div>
              <div class="mt-2 col-md-6 text-start">
                <label for="masterAccEmail" class="form-label">Email address</label>
                <input type="text" class="form-control" formControlName="masterAccEmail"
                       [readonly]="true" />

              </div>
              <div class="mt-2 col-md-6 text-start">
                <label for="masterAccProfession" class="form-label">Profession</label>
                <input type="text" class="form-control" [readonly]="true"
                       formControlName="masterAccProfession">
              </div>
              <div class="mt-2 col-md-6 text-start">
                <label for="masterAccCountryID" class="form-label">Country ID</label>
                <input type="text" class="form-control" aria-label="Default select example"
                       [readonly]="true" formControlName="masterAccCountryID">
              </div>
              <div class="mt-2 col-md-6 text-start">
                <label for="masterAccNationality" class="form-label">Nationality</label>
                <input type="text" class="form-control" [readonly]="true"
                       formControlName="masterAccNationality">
              </div>


              <div class="col-md-12 text-start mt-3" *ngIf="!isTableEmpty">
                <div>
                  <div class=" position-relative mt-3">
                    <li>
                      <label for="publicKey" class="form-label" style="font-weight: bold">Cash
                        Accounts</label>
                    </li>
                    <div class="table-container mt-3">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th scope="col">Cash A/C type</th>
                          <th scope="col">Cash A/C No</th>
                          <th scope="col">Currency</th>
                          <th scope="col">Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let cash of customerDetails?.['cashAccounts']">
                          <td *ngIf="cash.accountType == 0">Current</td>
                          <td *ngIf="cash.accountType == 1">Savings</td>
                          <td *ngIf="cash.accountType == 2">Investment</td>
                          <td>{{cash.cashAccountNumber}}</td>
                          <td>{{cash.currency}}</td>
                          <td *ngIf="cash.status == 2">APPROVED</td>
                          <td *ngIf="cash.status == 5">DELETE</td>
                          <td *ngIf="cash.status != 2 && cash.status != 5">
                            UNKNOWN
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class=" position-relative mt-5">
                    <li>
                      <label for="publicKey" class="form-label" style="font-weight: bold">Security
                        Accounts</label>
                    </li>
                    <div class="table-container mt-3">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th scope="col">Security A/C No</th>
                          <th scope="col">Account Type</th>
                          <th scope="col">Cash A/C No</th>
                          <th scope="col">Status</th>
                        </tr>
                        </thead>
                        <tbody *ngFor="let cash of customerDetails?.['cashAccounts']">
                        <tr *ngFor="let security of cash?.['securityAccounts']">
                          <td>{{security.accountNumber}}</td>
                          <td *ngIf="security.accountType == 1">Equity</td>
                          <td *ngIf="security.accountType == 2">Options</td>
                          <td *ngIf="security.accountType == 3">Futures</td>
                          <td *ngIf="security.accountType == 4">Forex</td>
                          <td *ngIf="security.accountType == 5">CFD</td>
                          <td *ngIf="security.accountType == 6">Spot</td>
                          <td *ngIf="security.accountType == 7">Auto Trade</td>
                          <td *ngIf="security.accountType == 8">Investment</td>
                          <td *ngIf="security.accountType == 10">crypto</td>
                          <td *ngIf="security.accountType == 11 ">
                            Investor Portfolio
                          </td>

                          <td>{{security.cashAccountNumber}}</td>

                          <td *ngIf="security.statusId == 2">APPROVED</td>
                          <td *ngIf="security.statusId == 5">DELETE</td>
                          <td *ngIf="security.statusId != 2 && security.statusId != 5">
                            UNKNOWN
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class=" position-relative mt-5">
                    <li>
                      <label for="publicKey" class="form-label" style="font-weight: bold">Trading
                        Accounts</label>
                    </li>
                    <div class="table-container mt-3">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th scope="col">Exchange</th>
                          <th scope="col">Trading Enable</th>
                          <th scope="col">Executing Broker</th>
                          <th scope="col">Status</th>
                        </tr>
                        </thead>
                        <ng-container *ngFor="let cash of customerDetails?.['cashAccounts']">
                          <tbody *ngFor="let security of cash?.['securityAccounts']">
                          <tr *ngFor="let exchange of security?.['exchangeAccounts']">
                            <td>{{exchange.exchange}}</td>

                            <td *ngIf="exchange.tradingEnabled == 1">Yes</td>
                            <td *ngIf="exchange.tradingEnabled == 0">No</td>
                            <td
                              *ngIf="exchange.tradingEnabled != 0 && exchange.tradingEnabled != 1 ">
                              null
                            </td>

                            <td *ngIf="exchange.executingBrokerId">
                              {{exchange.executingBrokerId}}
                            </td>
                            <td *ngIf="!exchange.executingBrokerId">null</td>

                            <td *ngIf="exchange.status == 3">APPROVED</td>
                            <td *ngIf="exchange.status == 6">DELETE</td>
                            <td *ngIf="exchange.status != 3 && exchange.status != 6">
                              UNKNOWN
                            </td>
                          </tr>
                          </tbody>
                        </ng-container>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #selectRow class="d-flex mt-5 mb-5">
  <div class="d-flex justify-content-center mt-5 mb-5" style=" min-height: 240px;">
    <div class="form-label">
      <h1 class="nodata-message">Select a Customer Profile to view</h1>
    </div>
  </div>
</ng-template>
<ng-template #selectRowSP class="d-flex mt-5 mb-5">
  <div class="d-flex justify-content-center mt-5 mb-5" style="min-width: 750px; min-height: 240px;">
    <div class="form-label">
      <h1 class="nodata-message">Select a Subscription package to view exchanges</h1>
    </div>
  </div>
</ng-template>
